import { isOfMetaOrigin } from "utils/marketing-url-params";
import { createTrackingUtils } from "../index";
import { CFAR_FULL_ON_COUNTRIES } from "@flights/ancillaries-universal";

const utils = createTrackingUtils({
  name: "flights_apex_web_cfar_on_sr_fd",
  stages: {
    affected_users: 1,
    main: 2,
    ddot: 3,
    mdot: 4,
    main_sr: 5,
    main_fd: 6,
    fd_imbalanced: 7,
    bf_sr: 8,
    cfar_and_flex_badges_sr: 9
  },
  goals: {
    action_click_with_cfar_badge_on_sr: 1
  },
  defaultStage: 1
});

const trackSearchResultsStages = (isMobile: boolean, hasBrandedFare: boolean, hasFlexAndCfar: boolean) => {
  utils.stages.main();
  utils.stages.main_sr();
  if (isMobile) utils.stages.mdot();
  if (!isMobile) utils.stages.ddot();
  if (hasBrandedFare) utils.stages.bf_sr();
  if (hasFlexAndCfar) utils.stages.cfar_and_flex_badges_sr();
};

const trackFlightDetailsStages = (isMobile: boolean) => {
  utils.stages.fd_imbalanced();
  if (!isOfMetaOrigin()) return;
  utils.stages.main();
  utils.stages.main_fd();
  if (isMobile) utils.stages.mdot();
  if (!isMobile) utils.stages.ddot();
};

const isEligablePos = (pointOfSale: string | undefined) =>
  CFAR_FULL_ON_COUNTRIES.includes((pointOfSale || "").toLowerCase());

export default { ...utils, trackSearchResultsStages, trackFlightDetailsStages, isEligablePos };
